import {createSelector} from 'reselect';
import {getTranslations, getCancellationPolicy, getTripData} from './store';
import {labelMaker} from '../../server/utils/labelMaker';
import {getCancellationPolicyUrl} from './system';
import {getIsIpmNonGuaranteedPricing} from './listing';

export const getEmptyPeriodsFallbackMessage = createSelector(
    [getTranslations, getCancellationPolicy, getIsIpmNonGuaranteedPricing, getTripData],
    (labels, cancellationPolicy, isIpmNonGuaranteedPricing, tripData) => {
        const {unstructuredPolicyFreeText, failedOnQuoteLoad} = cancellationPolicy;

        const hasDates = !!(tripData.arriveDateText && tripData.departDateText);
        // if has structured periods
        const hasCancellationPolicyPeriods = !!(cancellationPolicy.cancellationPolicyPeriods || [])
            .length;

        // Structured: doesn't show
        // Unstructured
        if (isIpmNonGuaranteedPricing) {
            if (hasDates && unstructuredPolicyFreeText) {
                return unstructuredPolicyFreeText;
            }
            if (!hasDates) {
                return labels.cancellationPolicyDatelessUnstructured;
            }
            if (failedOnQuoteLoad) {
                return labels.policyUnavailableMessageOwner;
            }
        } else if (
            // Structured: should be presented when dateless scenario and periods=null
            !hasCancellationPolicyPeriods
        ) {
            return labels.policyUnavailableMessageOwner;
        }
        return null;
    }
);

export const cancellationPolicySelector = createSelector(
    [
        getTranslations,
        getCancellationPolicyUrl,
        getCancellationPolicy,
        getEmptyPeriodsFallbackMessage
    ],
    (labels, cancellationPolicyUrl, cancellationPolicy, emptyPeriodsFallbackMessage) => {
        return {
            hasMultiplePeriods: (cancellationPolicy.cancellationPolicyPeriods || []).length > 1,
            labels,
            cancellationPolicy,
            cancellationPolicyLink: cancellationPolicyUrl
                ? labelMaker(labels.cancellationPolicyLink, {
                      link: cancellationPolicyUrl
                  })
                : null,
            policyText: emptyPeriodsFallbackMessage
        };
    }
);
